import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LoadingSpinner from '../../components/UI/LoadingSpinner';
import { toast } from 'react-toastify';

export default function OAuthCallback() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		const handleOAuthCallback = async () => {
			const token = searchParams.get('token');
			const error = searchParams.get('error');

			if (error) {
				toast.error('Authentication failed. Please try again.');
				navigate('/login');
				return;
			}

			if (!token) {
				toast.error('No authentication token received.');
				navigate('/login');
				return;
			}

			try {
				// Store token
				localStorage.setItem('token', token);
				
				// Fetch user profile with the token
				const response = await fetch('/api/auth/profile', {
					headers: {
						'Authorization': `Bearer ${token}`
					}
				});

				if (!response.ok) {
					throw new Error('Failed to fetch user profile');
				}

				await response.json();
				
				// Manually update the auth context state
				// We can't use the login function since we already have the token
				window.location.href = '/dashboard';
				
				toast.success('Successfully logged in!');
			} catch (error) {
				console.error('OAuth callback error:', error);
				toast.error('Authentication failed. Please try again.');
				localStorage.removeItem('token');
				navigate('/login');
			}
		};

		handleOAuthCallback();
	}, [searchParams, navigate]);

	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-50">
			<div className="text-center">
				<LoadingSpinner size="lg" />
				<p className="mt-4 text-gray-600">Completing authentication...</p>
			</div>
		</div>
	);
}

